module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Bold.6f9dbfbf.eot";